const chestAnteriorMale = require('../assets/chest_male_anterior.png');
const chestPosteriorMale = require('../assets/chest_male_posterior.png');

const chestAnteriorFemale = require('../assets/chest_female_anterior.png');
const chestPosteriorFemale = require('../assets/chest_female_posterior.png');

const lungAnteriorOverlay = require('../assets/lung_overlay_anterior.png');
const lungPosteriorOverlay = require('../assets/lung_overlay_posterior.png');

const heartOverlayAnterior = require('../assets/heart_overlay_anterior.png');

const maleChestSounds = [
  {
    picture: chestAnteriorMale,
    overlays: [lungAnteriorOverlay, heartOverlayAnterior],
    name: 'Anterior Sounds',
    testid: 'anterior-sounds',
    category: 'breath',
    orientation: 'front',
    spots: [
      {
        x: '48%',
        y: '13%',
        position: 0,
        tooltipPlacement: 'right',
      },
      {
        x: '49%',
        y: '29.5%',
        position: 1,
        tooltipPlacement: 'right',
      },
      {
        x: '31.3%',
        y: '48%',
        position: 2,
        tooltipPlacement: 'left',
      },
      {
        x: '65.7%',
        y: '48%',
        position: 3,
        tooltipPlacement: 'right',
      },
      {
        x: '53%',
        y: '73%',
        position: 0,
        label: 'H',
        spacer: true,
        category: 'heart',
        orientation: null,
        tooltipPlacement: 'right',
      },
    ],
  },
  {
    picture: chestPosteriorMale,
    overlay: lungPosteriorOverlay,
    name: 'Posterior Sounds',
    testid: 'posterior-sounds',
    category: 'breath',
    orientation: 'back',
    spots: [
      {
        x: '28.4%',
        y: '27%',
        position: 0,
        label: '5',
        tooltipPlacement: 'right',
      },
      {
        x: '33%',
        y: '51%',
        position: 1,
        label: '6',
        tooltipPlacement: 'right',
      },
      {
        x: '35%',
        y: '74%',
        position: 2,
        label: '7',
        tooltipPlacement: 'right',
      },
      {
        x: '68.4%',
        y: '27.5%',
        position: 3,
        label: '8',
        tooltipPlacement: 'left',
      },
      {
        x: '65.6%',
        y: '49%',
        position: 4,
        label: '9',
        tooltipPlacement: 'left',
      },
      {
        x: '63.5%',
        y: '74%',
        position: 5,
        label: '10',
        tooltipPlacement: 'left',
      },
    ],
  },
];

const femaleChestSounds = [
  { ...maleChestSounds[0], picture: chestAnteriorFemale },
  { ...maleChestSounds[1], picture: chestPosteriorFemale },
];

export default {
  CUSTOM: maleChestSounds,
  AMY: femaleChestSounds,
  BEN: maleChestSounds,
  HAWTHORN: maleChestSounds,
  JOSHUA: maleChestSounds,
  LEAH: femaleChestSounds,
  PATRICIA: femaleChestSounds,
  SHERYL: femaleChestSounds,
  MILITARY_AMY: femaleChestSounds,
  MILITARY_BEN: maleChestSounds,
  MILITARY_HAWTHORN: maleChestSounds,
  MILITARY_JOSHUA: maleChestSounds,
  MILITARY_LEAH: femaleChestSounds,
  MILITARY_PATRICIA: femaleChestSounds,
  MILITARY_SHERYL: femaleChestSounds,
  KIM: femaleChestSounds,
  LIAM: maleChestSounds,
  MILES: maleChestSounds,
};
